export default __webpack_public_path__ + "static/media/an-ps.d62ac047.svg";